import React, { useEffect } from 'react';
import * as cn from 'classnames';
import { IconButton, TextField, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';


import { Timer } from './Timer';
import './BmTimers.css';

export const BmTimers = () => {
    let timers = window.localStorage.getItem('timers');
    timers = timers 
        ? JSON.parse(timers)
        : [
            {
                className: 'p3-rolling-timer',
                title: 'Phase 3 Rolling',
                time: 35,
                warningTime: 20,
            },
            {
                className: 'fma-timer',
                title: 'FMA',
                time: 60,
                warningTime: 20,
            },
            {
                className: 'fma-entry-timer',
                title: 'FMA on entry',
                time: 70,
                warningTime: 20,
            },
        ];

    const [isAddingNewTimer, setIsAddingNewTimer] = React.useState(false);
    const [additionalTimers, setAdditionalTimers] = React.useState(timers);

    useEffect(() => {
        window.localStorage.setItem('timers', JSON.stringify(additionalTimers));
    }, [additionalTimers]);


    const AddNewTimer = () => {
        const [editingTimer, setEditingTimer] = React.useState({});

        const addTimer = () => {
            setAdditionalTimers([
                ...additionalTimers,
                {
                    ...editingTimer,
                    isCustom: true,
                },
            ]);
            setEditingTimer({});
            setIsAddingNewTimer(false);
        };

        const cancelAddTimer = () => {
            setEditingTimer({});
            setIsAddingNewTimer(false);
        }

        const numberRegex = /(\d+)/

        const { time, warningTime } = editingTimer;
        const isValidNumber = (num) => !!(numberRegex.test(num) && num > 0);
        const isValidWarningNumber = (num) => isValidNumber(num) && num < (time || 0) && num > 0;

        return (
            <div className='new-timer-input-container'>
                <div className='new-timer-input title'>
                    <TextField 
                        label='Timer name' 
                        variant='outlined' 
                        onChange={(e) => setEditingTimer({ ...editingTimer, title: e.target.value})}
                    />
                </div>
                <div className='new-timer-input time'>
                    <TextField 
                        error={time && !isValidNumber(time)}
                        label='Timer length (seconds)' 
                        variant='outlined' 
                        onChange={(e) => setEditingTimer({ ...editingTimer, time:  parseInt(e.target.value, 10)})}
                    />
                </div>
                <div className='new-timer-input warning-time'>
                    <TextField 
                        error={warningTime && !isValidWarningNumber(warningTime)}
                        label='Warning time (seconds)' 
                        variant='outlined' 
                        onChange={(e) => setEditingTimer({ ...editingTimer, warningTime:  parseInt(e.target.value, 10)})}
                    />
                </div>
                <Button className='new-timer-button save' variant='contained' color='primary' onClick={addTimer}>
                    Save
                </Button>
                <Button className='new-timer-button cancel' variant='contained' color='secondary' onClick={cancelAddTimer}>
                    Cancel
                </Button>
            </div>
        )
    }

    const removeCustomTimer = (customTimerTitle) => {
        setAdditionalTimers(additionalTimers.filter(({ title }) => customTimerTitle !== title));
    }
    
    return (
        <div className='blackmage-timers-container'>
            {additionalTimers.map(({ className, title, time, warningTime, isCustom }) => (
                <div className={cn('timer', className)}>
                    <span className={cn('label', className)} title={title}>
                        {title}
                    </span>
                    <Timer time={time} warningTime={warningTime} />
                    {isCustom && 
                        <IconButton 
                            className='delete-container'
                            color='secondary' 
                            aria-label='Delete timer' 
                            component='span'
                            onClick={() => removeCustomTimer(title)}
                        >
                            <Tooltip title="Delete timer">
                                <DeleteIcon />
                            </Tooltip>
                        </IconButton>
                    }
                </div>
            ))}
            {isAddingNewTimer 
                ? <AddNewTimer />
                : (
                    <Button className='add-new-timer' variant='contained' color='primary' onClick={() => setIsAddingNewTimer(true)}>
                        Add custom timer
                    </Button>
                )
            }
        </div>
    )
}